module.exports = __webpack_public_path__ + "static/media/form-lock-icon.31875575.svg";